import { BlockItemMedia } from '@/models/Blocks/Itens/block-item-media';
import { Picture} from '@/models/Muffin/picture';
import { BlockItemVideo } from '@/models/Blocks/Itens/Types/block-item-video';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';

export interface BlockProductPromo{
    label: string,
    timer?: number
}

export interface BlockProductPrice{
    value: string
    crossed?: string|null
}

export class BlockProduct extends BlockItemMedia {
    protected _groupId?: string;
    protected _name: string;
    protected _variant?: string;
    protected _price: BlockProductPrice;
    protected _promo?: BlockProductPromo;
    protected _ranking?: number;
    protected _page?: number;
    protected _transparentMode?: boolean;
    protected _hoverImages: Picture|null = null;
    protected _hoverVideo?: BlockItemVideo;
    protected _isFashion?: boolean;

    
    public constructor(name: string, prices: BlockProductPrice, groupId: string|undefined = undefined, promo: BlockProductPromo|undefined = undefined) {
        super(BlockItemType.product);
        this._groupId = groupId;
        this._name = name;
        this._price = prices;
        this._promo = promo;
    }

    public get name():string{
        return this._name;
    }

    public get variant():string|undefined{
        return this._variant;
    }

    public set variant(value: string|undefined){
        this._variant = value;
    }

    public get groupId():string|undefined{
        return this._groupId;
    }

    public get ranking():number|undefined{
        return this._ranking;
    }

    public set ranking(value: number|undefined){
        this._ranking = value;
    }

    public get transparentMode():boolean|undefined{
        return this._transparentMode;
    }

    public set transparentMode(value: boolean|undefined){
        this._transparentMode = value;
    }

    public get isFashion():boolean|undefined{
        return this._isFashion;
    }

    public set isFashion(value: boolean|undefined){
        this._isFashion = value;
    }

    public get price():BlockProductPrice{
        return this._price;
    }

    public get promo():BlockProductPromo|undefined{
        return this._promo;
    }

    public get hoverImages():Picture|null{
        if(this._hoverImages){
            this._hoverImages.title = this._name;
        }
        return this._hoverImages;
    }

    public set hoverImages(value: Picture|null){
        this._hoverImages = value;
    }

    public get hoverVideo():BlockItemVideo|undefined{
        return this._hoverVideo;
    }

    public set hoverVideo(value: BlockItemVideo){
        this._hoverVideo = value;
    }

    public get mubData():string|undefined{
        return !this.blockName ? this._mub : JSON.stringify({
            t: 'product',
            b: this.blockName,
            m:{
                id: this.groupId
            }
        });
    }

    public set mubData(value: string|undefined){
        this._mub = value;
    }

    public get page():number|undefined{
        return this._page;
    }

    public set page(value: number|undefined){
        this._page = value;
    }

    public addHoverImage(url: string, condition: string| null = null, isMain: boolean = false){
        this._hoverImages = this._addImage(this._hoverImages, url, condition, isMain);
    }
}